const Loading = () => {
  return (
    <div className="loading">
      <div>
        <div className="ring"></div>
      </div>
    </div>
  );
};

export default Loading;
